import { Color } from "chess.js"

const getTurn = (fen: string): Color => fen.split(" ")[1] as Color

const getNextTurn = (fen: string): Color => (getTurn(fen) === "w" ? "b" : "w")

export { getTurn, getNextTurn }
